import { IComponentOptions } from "angular";
import { MachinesMoveViewComponentController } from "./controller";
export const vsComponentName = "machinesDecommission";
export const machinesDecommissionMoveViewComponentOptions: IComponentOptions = {
  controller: MachinesMoveViewComponentController,
  controllerAs: "machinesDecommissionComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machineConfigurations: "<",
  },
};
